export const POLLING_INTERVALS_MILLIS = {
  HVAC: 30 * 1000,
} as const;